import React, { useRef, useMemo, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Visibility, Assessment, AddAlarm, History, Adjust, GridOn } from '@material-ui/icons';
import { Input, Autocomplete, Select } from '~/components/Form';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import Alert from '@material-ui/lab/Alert';
import qs from 'querystring';
import {
  ADM,
  GFE,
  GESTOR_UNIDATA_FINANCEIR,
  GESTOR_UNIDATA_COMERCIAL
} from '~/constants/perfil';

import { isArray, isEmpty } from 'lodash';
import { Container, ContainerTela, ContainerTela80, ContainerTela20 } from './styles';
import { number, downloadFile, t } from '~/helpers';
import { UnidataTable } from '~/components';
import api from '~/services/api';

import {
  findData,
  recordFiltering,
} from '~/store/modules/operacaoradadmdadosfaturamentoseplag/actions';

import DetalhePreFatura from './components/DetalhePreFatura';
import ImprimirDadosPeriodo from './components/ImprimirDadosPeriodo';
import AprovarPreFaturaDoGFO from './components/AprovarPreFaturaDoGFO';
import AprovarPreFaturaTodasDoGFO from './components/AprovarPreFaturaTodasDoGFO';
import AprovarFaturametoGFE from './components/AprovarFaturametoGFE';
import HistoricoPreFatura from './components/HistoricoPreFatura';
import ContestacaoPreFaturaPeloGFE from './components/ContestacaoPreFaturaPeloGFE';
import ReponderContestacaoPreFaturaPeloGFE from './components/ReponderContestacaoPreFaturaPeloGFE';


function OperacaoRadAdmDadosFaturamentoSeplag() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);
  const buttons = [];
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [totalAguardandoAprovarPreFaturaGFO, setTotalAguardandoAprovarPreFaturaGFO] = useState(0);

  const [totalAprovadosPreFaturaGFO, setTotalAprovadosPreFaturaGFO] = useState(0);
  const [totalAprovadosPreFaturaGFE, setTotalAprovadosPreFaturaGFE] = useState(0);

  const [totalContestacaoGestorOrgaoGFO, setTotalContestacaoGestorOrgaoGFO] = useState(0);
  const [totalContestacaoRespondidaUnidataOrgaoGFO, setTotalContestacaoRespondidaUnidataOrgaoGFO] = useState(0);
  const [totalCanceladaPorContestacaoGFO, setTotalCanceladaPorContestacaoGFO] = useState(0);

  const [totalContestacaoGestorGFE, setTotalContestacaoGestorGFE] = useState(0);
  const [totalContestacaoRespondidaUnidataGFE, setTotalContestacaoRespondidaUnidataGFE] = useState(0);

  const [totalAprovarPreFatura, setTotalAprovarPreFatura] = useState(0);

  //AprovarPreFatura  ou AprovarFaturamento ou Carregando
  const [senario, setSenario] = React.useState('Carregando');

  const [senarioStatusErro, setSenarioStatusErro] = React.useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(true);
  const [load, setLoad] = useState(true);

  const [quantitativoVeiculosValorTota, setQuantitativoVeiculosValorTota] = useState({});

  const status = useMemo(
    () => [
      { value: 'Aguardando Aprovação Gestor do Órgão', label: '1' },
      { value: 'Aprovado Gestor do Órgão', label: '201' },
      { value: 'Aprovado Gestor do Estado', label: '202' },
      { value: 'Cancelada por Contestação', label: '8' },
      { value: 'Contestação do Gestor do Órgão', label: '2' },
      { value: 'Contestação do Gestor do Órgão respondida pela Abastek', label: '3' },
      { value: 'Contestação do Gestor do Estado', label: '302' },
      { value: 'Contestação do Gestor do Estado respondida pela Abastek', label: '303' },
    ],
    []
  );

  const [lPemiteEditarPermiteAprovarGFE, setLPemiteEditarPermiteAprovarGFE] = useState(false);

  const [lPemiteEditarContestacaoDoGFE, setLPemiteEditarContestacaoDoGFE] = useState(false);

  const data = useSelector(
    (state) => state.operacaoradadmdadosfaturamentoseplag
  );

  const detalhePreFaturaRef = useRef(null);
  const imprimirDadosPeriodoRef = useRef(null);
  const aprovarPreFaturaDoGFORef = useRef(null);
  const aprovarPreFaturaTodasDoGFORef = useRef(null);
  const aprovarFaturametoGFERef = useRef(null);
  const historicoPreFaturaRef = useRef(null);
  const contestacaoPreFaturaPeloGFERef = useRef(null);
  const reponderContestacaoPreFaturaPeloGFERef = useRef(null);


  const handleGetAPIquantitativoveiculosvalortotal = useCallback(async (lperiodo, lperiodoconsultainiinicial, lperiodoconsultafiminicial, lLogin) => {
    // setLoading(true);
    try {
      if (!lperiodo)
        setQuantitativoVeiculosValorTota({});
      else {

        let specificDate = moment(lperiodoconsultainiinicial);
        let novainiData = specificDate.add(5, 'days');
        let dataini = moment(novainiData, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');

        specificDate = moment(lperiodoconsultafiminicial);
        let novaData = specificDate.add(10, 'days');
        let datafim = moment(novaData, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');

        // const response = await api.get(`quantitativoveiculosvalortotal/${id}`);

        // lperiodo, lperiodoconsultainiinicial, lperiodoconsultafiminicial, lLogin

        // const response = await api.get(`quantitativoveiculosvalortotal/${lperiodo}/${lperiodoconsultainiinicial}/${lperiodoconsultafiminicial}/${lLogin}`);
        const response = await api.get('/quantitativoveiculosvalortotal', {
          params: { lperiodo: lperiodo, lperiodoconsultainiinicial: dataini, lperiodoconsultafiminicial: datafim, lLogin: lLogin },
          paramsSerializer: (param) => qs.stringify(param),
        });

        console.log(response);
        setQuantitativoVeiculosValorTota(response.data);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));

      setQuantitativoVeiculosValorTota({});
    } finally {
      // setLoading(false);
    }
  }, []);


  const handleGetSenario = React.useCallback(async () => {
    const wherefield = [];
    const valuewherefield = [];
    const typewherefield = [];

    wherefield.push('fatu_status');
    valuewherefield.push("1, 201, 202, 2, 3, 302, 303");
    typewherefield.push("IN");
    const search = { wherefield, valuewherefield, typewherefield };
    setLoad(true);
    try {
      setSenarioStatusErro(false);
      const { data } = await api.get('/radadmdadosfaturamentoseplag', {
        params: { ...search, pagesize: 99999, pesquisalista: true, page: 1, },
        paramsSerializer: (param) => qs.stringify(param),
      });

      console.log(data.items);

      if (!isEmpty(data)) {



        setTotalRegistros(data.totalCount); //Total de registros

        let filterRegs = data.items.filter(item => item.fatu_status === 1);
        setTotalAguardandoAprovarPreFaturaGFO(filterRegs.length);

        filterRegs = data.items.filter(item => item.fatu_status === 2);
        setTotalContestacaoGestorOrgaoGFO(filterRegs.length);

        filterRegs = data.items.filter(item => item.fatu_status === 3);
        setTotalContestacaoRespondidaUnidataOrgaoGFO(filterRegs.length);

        filterRegs = data.items.filter(item => item.fatu_status === 8);
        setTotalCanceladaPorContestacaoGFO(filterRegs.length);


        filterRegs = data.items.filter(item => item.fatu_status === 201);
        setTotalAprovadosPreFaturaGFO(filterRegs.length);

        filterRegs = data.items.filter(item => item.fatu_status === 202);
        setTotalAprovadosPreFaturaGFE(filterRegs.length);

        filterRegs = data.items.filter(item => item.fatu_status === 302);
        setTotalContestacaoGestorGFE(filterRegs.length);

        filterRegs = data.items.filter(item => item.fatu_status === 303);
        setTotalContestacaoRespondidaUnidataGFE(filterRegs.length);

        setSenarioStatusErro(false);

        if (data.totalCount > 0) {
          const primeiroElemento = data.items[0];

          handleGetAPIquantitativoveiculosvalortotal(
            primeiroElemento.fatu_periodo,
            primeiroElemento.fatu_data_inicio,
            primeiroElemento.fatu_data_fim,
            "sgta"
          )
        }

      }

      // setTanks(data.items);
    } catch (err) {

      setSenarioStatusErro(true);
      setLoad(false);

      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoad(false);
    }
  }, []);

  useEffect(() => {

    if (totalRegistros > 0) {


      if (((totalAguardandoAprovarPreFaturaGFO) > 0)
        || (totalContestacaoGestorOrgaoGFO > 0)
        || (totalContestacaoRespondidaUnidataOrgaoGFO > 0)

        || (totalContestacaoRespondidaUnidataGFE > 0)
        || (totalContestacaoGestorGFE > 0)

      ) {
        setSenario('AprovarPreFatura')
      } else {
        setSenario('AprovarFaturamento')
      }

    } else {
      setSenario('SemRegistros')
    }
  }, [
    totalRegistros,
    totalAguardandoAprovarPreFaturaGFO,
    totalAprovadosPreFaturaGFO,
    totalAprovadosPreFaturaGFE,
    totalAprovarPreFatura,
    totalContestacaoGestorOrgaoGFO,
    totalContestacaoRespondidaUnidataOrgaoGFO,
    totalContestacaoRespondidaUnidataGFE,
    totalContestacaoGestorGFE
  ]);

  // Initial data
  useEffect(() => {
    handleGetSenario();
  }, []);


  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(data.params));
    handleGetSenario();
  }, [data.params]);

  const openWin = React.useCallback((url) => {
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=1,left=1, fullscreen");
  }, []);

  const openWinBaixarArquivo = React.useCallback((url) => {
    downloadFile(url);
  }, []);

  const historicoPeriodo = React.useCallback((value) => {
    openWinBaixarArquivo(value.cosi_url_aplic_rel_rad_getpdf);
  }, []);

  const historicoPeriodoxls = React.useCallback((value) => {
    openWinBaixarArquivo(value.cosi_url_aplic_rel_rad_getexcel);
  }, []);


  const header2 = useMemo(
    () => {
      let tempArrayHeader = [
        {
          id: 'orga_sigla',
          label: 'Órgão Sigla',
          align: 'left',
          filter: {
            type: 'text',
          },
        },
        {
          id: 'fatu_codigo',
          label: 'Pré-fatura',
          filter: {
            type: 'text',
          },
          align: 'right',
        },

        {
          id: 'fatu_status_str',
          label: 'Status',
          align: 'center',
          converter: status,
          filter: profile.perfcodigo !== String(GESTOR_UNIDATA_COMERCIAL) ? {
            type: 'select',
            options: status,
          } : undefined,
        },

        {
          id: 'fatu_equipamentos_faturados',
          label: 'Quantidade veículos faturados',
          align: 'right',
        },
        {
          id: 'fatu_equipamentos_instalados',
          label: 'Quantidade veículos instalados',
          align: 'right',
        },

        {
          id: 'fatu_valor_servico',
          label: 'Valor do Serviço (R$)',
          formatted: (value) => number(value, 'currency'),
          align: 'right',
        },

        {
          id: 'fatu_total_retencao',
          label: 'Total das retenções (R$)',
          formatted: (value) => number(value, 'currency'),
          align: 'right',
        },


      ]

      senario === 'AprovarPreFatura' && tempArrayHeader.push(
        {
          id: 'dias_pendete_gfo',
          label: 'Prazo de aprovação pré-fatura GFO',
          align: 'center',
          styled: (value) => Number(value?.dias_pendete_gfo) < 0 ? ({ color: '#ff0000' }) : ({ color: '#00B300' }),
        },
      )

      senario === 'AprovarFaturamento' && tempArrayHeader.push(
        {
          id: 'dias_pendete_gfe',
          label: 'Prazo de aprovação faturamento GFE',
          align: 'center',
          styled: (value) => Number(value?.dias_pendete_gfe) < 0 ? ({ color: '#ff0000' }) : ({ color: '#00B300' }),
        },
      )

      return tempArrayHeader
    },
    [senario]
  );


  const header = useMemo(() => [
    {
      id: 'orga_sigla',
      label: 'Órgão Sigla',
      align: 'left',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'fatu_codigo',
      label: 'Pré-fatura',
      filter: {
        type: 'text',
      },
      align: 'right',
    },

    {
      id: 'fatu_status_str',
      label: 'Status',
      align: 'center',
      converter: status,
      filter: profile.perfcodigo !== String(GESTOR_UNIDATA_COMERCIAL) ? {
        type: 'select',
        options: status,
      } : undefined,
    },

    {
      id: 'fatu_equipamentos_faturados',
      label: 'Quantidade veículos faturados',
      align: 'right',
    },
    {
      id: 'fatu_equipamentos_instalados',
      label: 'Quantidade veículos instalados',
      align: 'right',
    },

    {
      id: 'fatu_valor_servico',
      label: 'Valor do Serviço (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },

    {
      id: 'fatu_total_retencao',
      label: 'Total das retenções (R$)',
      formatted: (value) => number(value, 'currency'),
      align: 'right',
    },

    {
      id: 'dias_pendete_gfo',
      label: 'Prazo de aprovação pré-fatura GFO',
      align: 'center',
      styled: (value) => Number(value?.dias_pendete_gfo) < 0 ? ({ color: '#ff0000' }) : ({ color: '#00B300' }),
    },

    {
      id: 'dias_pendete_gfe',
      label: 'Prazo de aprovação faturamento GFE',
      align: 'center',
      styled: (value) => Number(value?.dias_pendete_gfe) < 0 ? ({ color: '#ff0000' }) : ({ color: '#00B300' }),
    },

  ], []);

  const headerHabbuttons = useMemo(() => [

    buttons.push({
      title: 'Histórico da Pré-fatura',
      action: (value) =>
        historicoPreFaturaRef.current.handleToggleModal(value),
      icon: <History />,
    }),

    ((profile.perfcodigo === String(GFE))) &&
    ((lPemiteEditarContestacaoDoGFE === true)) &&
    // ((lPemiteEditarPermiteAprovarGFE === true) || (lPemiteEditarContestacaoDoGFE === true)) &&
    senario === 'AprovarPreFatura' && buttons.push({
      title: 'Contestar pré-fatura GFE',
      action: (value) => contestacaoPreFaturaPeloGFERef.current.handleToggleModal(value),
      icon: <Adjust />,
    }),

    ((profile.perfcodigo === String(ADM))) &&
    ((lPemiteEditarPermiteAprovarGFE === true) || (lPemiteEditarContestacaoDoGFE === true)) &&
    senario === 'AprovarPreFatura' && buttons.push({
      title: 'Responder contestação do gestor do Estado',
      action: (value) => reponderContestacaoPreFaturaPeloGFERef.current.handleToggleModal(value),
      icon: <Adjust />,
    }),

    ((profile.perfcodigo === String(GFE)) || (profile.perfcodigo === String(ADM))) &&
    lPemiteEditarPermiteAprovarGFE === true &&
    senario === 'AprovarPreFatura' && buttons.push({
      title: 'Aprovar pelo GFO',
      action: (value) => aprovarPreFaturaDoGFORef.current.handleToggleModal(value),
      icon: <AddAlarm />,
    }),

    buttons.push({
      title: 'Relatório analítico de despesas',
      action: (value) => detalhePreFaturaRef.current.handleToggleModal(value),
      icon: <Visibility />,
    }),

    buttons.push({
      title: 'Dados do Período XLS',
      action: (value) => historicoPeriodoxls(value),
      icon: <GridOn />,
    }),
    buttons.push({
      title: 'Dados do Período PDF',
      action: (value) => historicoPeriodo(value),
      icon: <Assessment />,
    }),

    ''
  ], [data, profile, itemSelecionado, senario, lPemiteEditarPermiteAprovarGFE,
    totalContestacaoGestorOrgaoGFO, totalContestacaoRespondidaUnidataOrgaoGFO,
    lPemiteEditarContestacaoDoGFE
  ]);

  const registroSelecionado = React.useCallback((values) => {

    switch (profile.gloperfilid) {
      case GFE:
        if ((values.fatu_status === 1)
          || (values.fatu_status === 2)
          || (values.fatu_status === 3)
          || (values.fatu_status === 302)
          || (values.fatu_status === 303)
        ) {
          setLPemiteEditarPermiteAprovarGFE(true);
        } else {
          setLPemiteEditarPermiteAprovarGFE(false);
        }

        if (values.fatu_status === 302) {
          setLPemiteEditarContestacaoDoGFE(false);
        } else {
          if ((values.fatu_status === 1)
            || (values.fatu_status === 2)
            || (values.fatu_status === 3)
            || (values.fatu_status === 302)
            || (values.fatu_status === 303)
          ) {
            setLPemiteEditarContestacaoDoGFE(true);
          } else {
            setLPemiteEditarContestacaoDoGFE(false);
          }
        }


        break;
      case ADM:
        if (values.fatu_status === 302) {
          setLPemiteEditarContestacaoDoGFE(true);
        } else {
          setLPemiteEditarContestacaoDoGFE(false);
        }
        break;
      default:
        setLPemiteEditarPermiteAprovarGFE(false);
        setLPemiteEditarContestacaoDoGFE(false);
    }

    setItemSelecionado(values);

  }, [data])

  const filter = useMemo(() => [
    {
      id: 'orga_codigo',
      label: 'Órgão',
      type: 'autocomplete',
      autocomplete: {
        url: 'orgaos',
        label: 'orga_nome',
        unique: 'orga_codigo',
        params: {
          fieldlist: 'orga_codigo, orga_nome',
        }
      }
    }
  ], []);

  return (
    <>


      <Container>
        {!senario ? ''
          : ((senario === 'Carregando') || (load)) ? (
            <Alert severity="error">Carregando dados...</Alert>
          ) : ((senario === 'AprovarPreFatura') || (senario === 'AprovarFaturamento')) ? (
            <Alert severity="success">Aprovar Pré-Fatura ou Faturamento</Alert>
          ) : ((senario === 'SemRegistros') && (!senarioStatusErro)) ? (
            <Alert severity="success">Sem Registros</Alert>
          ) : (
            <Alert severity="error">Falha na conexão com o servidor Abastek</Alert>
          )}

        {/* {!senario ? ''
          : ((senario === 'Carregando') || (load)) ? (
            <Alert severity="error">Carregando dados...</Alert>
          ) : senario === 'AprovarPreFatura' ? (
            <Alert severity="success">Aprovar Pré-Fatura</Alert>
          ) : senario === 'AprovarFaturamento' ? (
            <Alert severity="success">Aprovar Faturamento</Alert>
          ) : ((senario === 'SemRegistros') && (!senarioStatusErro)) ? (
            <Alert severity="success">Sem Registros</Alert>
          ) : (
            <Alert severity="error">Falha na conexão com o servidor Abastek</Alert>
          )} */}

        {/* {(
          (senario === 'AprovarPreFatura')
          && (profile.gloperfilid === GFE)
        )
          ? (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={(modoIn) =>
                  aprovarPreFaturaTodasDoGFORef.current.handleToggleModal(modoIn)
                }
              >
                Aprovar todas pré-faturas pendentes do GFO
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={(modoIn) =>
                  imprimirDadosPeriodoRef.current.handleToggleModal(modoIn)
                }
              >
                Imprimir relatório do período
              </Button>
            </>

          ) :
          (senario === 'AprovarPreFatura') ? (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={(modoIn) =>
                  imprimirDadosPeriodoRef.current.handleToggleModal(modoIn)
                }
              // disabled={isGfeC}
              >
                Imprimir relatório do período
              </Button>
            </>
          ) : ''
        } */}

        {/* {senario === 'AprovarFaturamento' ? (
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={(modoIn) =>
                aprovarFaturametoGFERef.current.handleToggleModal(modoIn)
              }
            >
              Aprovar faturamento
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={(modoIn) =>
                imprimirDadosPeriodoRef.current.handleToggleModal(modoIn)
              }
            >
              Imprimir relatório do período
            </Button>
          </>

        ) : ''} */}

        {((senario === 'AprovarPreFatura') || (senario === 'AprovarFaturamento')) ? (

          <>
            <Button
              variant="contained"
              color="primary"
              onClick={(modoIn) =>
                aprovarPreFaturaTodasDoGFORef.current.handleToggleModal(modoIn)
              }
            >
              Aprovar todas pré-faturas pendentes do GFO
            </Button>

            {/* <Button
            variant="contained"
            color="primary"
            onClick={(modoIn) =>
              imprimirDadosPeriodoRef.current.handleToggleModal(modoIn)
            }
          >
            Imprimir relatório do período
          </Button> */}

            <Button
              variant="contained"
              color="primary"
              onClick={(modoIn) =>
                aprovarFaturametoGFERef.current.handleToggleModal(modoIn)
              }
            >
              Aprovar faturamento
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={(modoIn) =>
                imprimirDadosPeriodoRef.current.handleToggleModal(modoIn)
              }
            >
              Imprimir relatório do período
            </Button>

          </>
        ) : ''}


      </Container>

      {((senario === 'AprovarPreFatura') || (senario === 'AprovarFaturamento')) ? (
        <ContainerTela>



          <ContainerTela80>
            <UnidataTable
              create={false}
              delete={false}
              update={false}
              dense
              fixed
              header={header}
              find={findData}
              redux={data}
              read={recordFiltering}
              actions={buttons}
              detach="fatu_codigo"
              // maxHeight="100px"
              maxHeight="58vh"

              custom={filter}
              query={{
                wherefield: ['fatu_status'],
                valuewherefield: ["201, 202, 8, 1, 2, 3, 8, 201, 202, 302, 303"],
                typewherefield: ['IN'],
              }}
              onRow={(values) => registroSelecionado(values)}
            />
          </ContainerTela80>

          <ContainerTela20>
            {!isEmpty(quantitativoVeiculosValorTota) ?
              `Período: ${quantitativoVeiculosValorTota.lperiodo} -
               Quantitativo: ${quantitativoVeiculosValorTota.fatu_equipamentos_faturados}
               - Valor Total:  (R$) ${number(quantitativoVeiculosValorTota.fatu_valor_nota_fiscal_moeda_00, 'currency')}`
              : ""
            }
          </ContainerTela20>


        </ContainerTela>
      ) : ''}







      {/* {senario === 'AprovarPreFatura' ? (
        <>
          <UnidataTable
            create={false}
            delete={false}
            update={false}
            dense
            fixed
            header={header}
            find={findData}
            redux={data}
            read={recordFiltering}
            actions={buttons}
            detach="fatu_codigo"
            maxHeight="65vh"
            custom={filter}
            query={{
              wherefield: ['fatu_status'],
              valuewherefield: ["1, 2, 3, 8, 201, 202, 302, 303"],
              typewherefield: ['IN'],
            }}
            onRow={(values) => registroSelecionado(values)}
          />
        </>
      ) : ''}

      {senario === 'AprovarFaturamento' ? (
        <>
          <UnidataTable
            create={false}
            delete={false}
            update={false}
            dense
            fixed
            header={header}
            find={findData}
            redux={data}
            read={recordFiltering}
            actions={buttons}
            detach="fatu_codigo"
            maxHeight="65vh"
            custom={filter}
            query={{
              wherefield: ['fatu_status'],
              valuewherefield: ["201, 202, 8"],
              typewherefield: ['IN'],
            }}
            onRow={(values) => registroSelecionado(values)}
          />
        </>
      ) : ''} */}

      <DetalhePreFatura ref={detalhePreFaturaRef} update={() => handleUpdate()} name="DetalhePreFatura" />
      <ImprimirDadosPeriodo ref={imprimirDadosPeriodoRef} update={() => handleUpdate()} name="ImprimirDadosPeriodo" />
      <AprovarPreFaturaDoGFO ref={aprovarPreFaturaDoGFORef} update={() => handleUpdate()} name="AprovarPreFaturaDoGFO" />
      <AprovarPreFaturaTodasDoGFO ref={aprovarPreFaturaTodasDoGFORef} update={() => handleUpdate()} name="AprovarPreFaturaTodasDoGFO" />
      <AprovarFaturametoGFE ref={aprovarFaturametoGFERef} update={() => handleUpdate()} name="AprovarFaturametoGFE" />
      <HistoricoPreFatura ref={historicoPreFaturaRef} update={() => handleUpdate()} name="HistoricoPreFatura" />
      <ContestacaoPreFaturaPeloGFE ref={contestacaoPreFaturaPeloGFERef} update={() => handleUpdate()} name="ContestacaoPreFaturaPeloGFE" />
      <ReponderContestacaoPreFaturaPeloGFE ref={reponderContestacaoPreFaturaPeloGFERef} update={() => handleUpdate()} name="ReponderContestacaoPreFaturaPeloGFE" />

    </>
  );
}

export default OperacaoRadAdmDadosFaturamentoSeplag;

